exports.list = {
    path: '/pengeluaran_equipment',
    name: 'pengeluaran_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/pengeluaran_equipment/List.vue"),
}
exports.show = {
    path: '/pengeluaran_equipment/show/:id',
    name: 'pengeluaran_equipment_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pengeluaran_equipment/Show.vue"),
}